export default "__VITE_ASSET__DKCp1Pjm__"